const MEP_KEY = "AIzaSyCNvFg98vn8Xu-__WvIlbjdDMwA22eAJi8";
export default MEP_KEY;